import { CloudOff, Database, Sparkles } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { AsistenteStatus } from '../asistente.types';

interface AssistantStatusBadgeProps {
  status: AsistenteStatus | undefined;
  loading: boolean;
  isError: boolean;
  className?: string;
}

/** Pastilla con el estado del servicio de IA y el nº de consultas disponibles. */
export function AssistantStatusBadge({
  status,
  loading,
  isError,
  className,
}: AssistantStatusBadgeProps) {
  const disponible = Boolean(status?.disponible) && !isError;

  if (loading) {
    return (
      <span className={cn('inline-flex items-center gap-2 text-xs font-medium text-ink-400', className)}>
        <span className="size-1.5 animate-pulse rounded-full bg-amber-400" />
        Verificando servicio…
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium',
        disponible
          ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
          : 'border-rose-200 bg-rose-50 text-rose-700',
        className,
      )}
      title={disponible ? undefined : (status?.motivo ?? 'Servicio no disponible')}
    >
      {disponible ? (
        <>
          <Sparkles className="size-3.5" aria-hidden="true" />
          {/* El modelo que hay detrás no se muestra al usuario: es un detalle de
              implementación que puede cambiar sin aviso. */}
          <span className="flex items-center gap-1 text-emerald-600/80">
            <Database className="size-3" aria-hidden="true" />
            {status?.herramientas} consultas
          </span>
        </>
      ) : (
        <>
          <CloudOff className="size-3.5" aria-hidden="true" />
          No disponible
        </>
      )}
    </span>
  );
}
